import {types} from 'mobx-state-tree';
import WithFeedbackModel from '../composables/withFeedbackModel';

export const StaahTeamSettingModel = types.model({
  id: types.identifierNumber,
  code: types.string,
  name: types.string,
  teamId: types.number,
  params: types.model({
    hotelId: types.string,
    username: types.string,
    password: types.string
  })
});

export const TeamSettingsModel = types.compose(
  types.model('TeamSettings', {
    teamSetting: types.maybe(
      types.model({
        webhookSetting: types.maybe(
          types.model({
            id: types.identifierNumber,
            code: types.string,
            name: types.string,
            teamId: types.number,
            params: types.model({
              url: types.string
            })
          })
        ),
        financeSetting: types.maybe(
          types.model({
            id: types.identifierNumber,
            code: types.string,
            name: types.string,
            teamId: types.number,
            params: types.model({
              preferCurrency: types.optional(types.string, ''),
              defaultCashier: types.optional(types.string, ''),
              defaultBelongTo: types.optional(types.string, ''),
              cohostCommission: types.optional(types.number, 0),
              bankAccount: types.optional(
                types.model({
                  bankName: types.optional(types.string, ''),
                  numberAccount: types.optional(types.string, ''),
                  cardHolder: types.optional(types.string, ''),
                  branch: types.optional(types.string, '')
                }),
                {}
              )
            })
          })
        ),

        facebookSetting: types.maybe(
          types.model({
            id: types.identifierNumber,
            code: types.string,
            name: types.string,
            teamId: types.number,
            params: types.model({
              memberIds: types.array(types.integer),
              pages: types.array(
                types.model({
                  id: types.string,
                  name: types.string,
                  avatar: types.string,
                  token: types.string
                })
              )
            })
          })
        ),

        zaloSetting: types.maybe(
          types.model({
            id: types.identifierNumber,
            code: types.string,
            name: types.string,
            teamId: types.number,
            params: types.model({
              memberIds: types.array(types.integer),
              oas: types.array(
                types.model({
                  id: types.string,
                  name: types.string,
                  avatar: types.string,
                  token: types.string
                })
              )
            })
          })
        ),
        airtableSetting: types.maybe(
          types.model({
            id: types.identifierNumber,
            code: types.string,
            name: types.string,
            teamId: types.number,
            params: types.model({
              pushReservation: types.array(
                types.model({
                  baseId: types.string,
                  token: types.string,
                  tableName: types.string
                })
              )
            })
          })
        ),
        staahSetting: types.maybe(StaahTeamSettingModel)
      })
    )
  }),
  WithFeedbackModel
);

export type TeamSettingsModelType = typeof TeamSettingsModel.Type;

export type StaahTeamSettingModelType = typeof StaahTeamSettingModel.Type;

export default TeamSettingsModel;



// WEBPACK FOOTER //
// ./src/models/TeamSettingsModel/TeamSettingsModel.ts